import React, { lazy } from 'react';
import { Route } from 'react-router';

const Usage = lazy(() => import('legacy-src/components/usage/Usage'));

export default <Route name="usage" path="usage" component={Usage} />;
